<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (custom)="onCustom($event)"
                  (detail)="onDetail($event)"
                  [columns]="columns"
                  [dataProviderParams]="params"
                  [dataProvider]="importService"
                  [icon]="'receipt'"
                  [title]="'Failed imports'"
                  noDataMessage="Hooray no imports failing"></data-table>
</page-content>
